module.exports = __webpack_public_path__ + "img/index.f8b74431.svg";